import React from "react";
import { useContext } from "react";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";

import { GlobalContext } from "../../globals/globalContext";

import "./cardTitle.styles.styl";

const CardProductTitle = (props) => {
  const {
    article_name_without_qualities,
    article_name_with_qualities,
    subTitle,
    article_quality,
    base_price_display,
    container_contents,
    display_inactive,
    isListCard,
    incl_deposit,
    isItemOpen,
    producer_display,
    position,
    hideSoldOutProps,
    soldOutText,
  } = props;
  const { windowWidth } = useContext(GlobalContext);
  const isCatalog = position == "catalog";
  const isOpenListCard = isListCard && isItemOpen;

  if (!isItemOpen)
    return (
      <div
        className={isListCard ? "cart-item__title" : "card-product__title-grid"}
      >
        <p
          className={classNames("card-product__title", {
            [`card-product__title-no-quality`]: windowWidth < 640 && !isCatalog,
            [`card-product__closed-title-quality`]: windowWidth >= 640,
          })}
        >
          {article_name_with_qualities}
          {display_inactive && (
            <>
              <br />
              <br />
              <span id="soldOutText">{soldOutText}</span>
            </>
          )}
        </p>
        {!hideSoldOutProps && (
          <>
            {incl_deposit && (
              <p className="card-product__deposit">{incl_deposit}</p>
            )}
            <p className="sub-title">{subTitle}</p>
            <p className="per-base-unit">{base_price_display}</p>
            {container_contents && (
              <p className="container-contents">
                {" "}
                <FormattedMessage id="contents" />: {container_contents}
              </p>
            )}
          </>
        )}
      </div>
    );

  return (
    <div
      className={classNames("card-product__main", {
        "card-product__open card-product__title": isItemOpen,
        "card-product__sml-title": isItemOpen && windowWidth < 640,
      })}
    >
      <div className="card-product__info">
        <p className="card-product__info__title">
          {article_name_without_qualities}
        </p>
        <p className="card-product__info__subTitle">{subTitle}</p>
      </div>
      <div className="card-product__producer-deposit">
        <p className="card-product__producer-deposit-item">{article_quality}</p>
        <p className="card-product__producer-deposit__base_price_display">
          {base_price_display}
        </p>
      </div>
      <div className="card-product__producer-deposit">
        {!isOpenListCard && (
          <p className="card-product__producer-deposit-item">
            {producer_display}
          </p>
        )}
        <p className="card-product__producer-deposit__deposit">
          {incl_deposit}
        </p>
      </div>
    </div>
  );
};

export default CardProductTitle;
